var scope_0 = require('/opt/build/repo/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/09434b09c8c64be4da7ee3b61d03a971.js').default;
var scope_1 = require('/opt/build/repo/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3238462f4ec89cd36bdea9b590901336.js').default;
var scope_2 = require('/opt/build/repo/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3964b53501ea42f39694dcab8ce41641.js').default;
var scope_3 = require('/opt/build/repo/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3bc86d645ec0f23651fb9648d8210576.js').default;
var scope_4 = require('/opt/build/repo/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/810b14a6cdad403b6ddddb665e105748.js').default;
var scope_5 = require('/opt/build/repo/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8bb5c0a5b574ea7dc6bf442e83c6ff0e.js').default;
var scope_6 = require('/opt/build/repo/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/96b987ae6b3a9c78e00624c16b322056.js').default;
var scope_7 = require('/opt/build/repo/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9a6d64d8dd0dc3d009185e575e34b34f.js').default;
var scope_8 = require('/opt/build/repo/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a576be0c109a02b2081038da30e93f82.js').default;
var scope_9 = require('/opt/build/repo/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ad8d1c700837d93713a40a9b67a3187f.js').default;
var scope_10 = require('/opt/build/repo/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b3d0d7cc4f86741e1e3f6747f57719c7.js').default;
var scope_11 = require('/opt/build/repo/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e23f8c479e05e3b5d551e954228399c0.js').default;
var scope_12 = require('/opt/build/repo/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_13 = require('/opt/build/repo/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ee3dcb3f990be1db0fb738c1ec4a1d14.js').default;
var scope_14 = require('/opt/build/repo/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/fcd70a2adcb73bc916bf857ff9d758d0.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9,
scope_10,
scope_11,
scope_12,
scope_13,
scope_14 )
    